import React from "react";
import Count from "./Count";
import { getValue } from "../utils/dashboardUtils";

const DashboardCards = ({ schemaDashboard, presenter, objects, onClick }) => (
  <div className="row mt-1 g-3" id="chart-container30">
    {schemaDashboard.map((obj, idx) => {
      const { value, percentage } = getValue(obj.label, presenter);
      return (
        <div key={idx} className="col-6 col-md-3">
          <Count
            {...obj}
            val={value}
            percentage={percentage}
            onClick={() => onClick(obj.navigationTarget)}
          />
        </div>
      );
    })}
  </div>
);

export default DashboardCards;
